/** @format */

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import CustomButtom from '../../components/CustomButtons/ButtonExt';
import I18n from '../../components/Translate/I18n';

class CustomTextButtom extends PureComponent {
    constructor(props) {
        super(props);

        const { buttonGroupColor, buttonGroupSize, size, color } = this.props;

        let c = color;
        let s = size;
        if (buttonGroupColor) {
            c = buttonGroupColor;
        }
        if (buttonGroupSize) {
            s = buttonGroupSize;
        }

        this.state = {
            c: c,
            s: s,
        };
    }

    changeColor = (colorName) => this.setState({ c: colorName });

    render() {
        const { callback, label, callbackParam, className, disabled, buttonGroupColor, valueObject, fullWidth,simple } = this.props;
        const { c, s } = this.state;
        let color = c;
        if (buttonGroupColor) {
            color = buttonGroupColor;
        }

        return (
            <CustomButtom
                simple={simple}
                fullWidth={!!fullWidth}
                color={color}
                disabled={disabled}
                className={className}
                size={s}
                onClick={() => callback(callbackParam)}
            >
                <I18n trans={label} valueObject={valueObject} />
            </CustomButtom>
        );
    }
}

CustomTextButtom.propTypes = {
    callback: PropTypes.func.isRequired,
    callbackParam: PropTypes.object,
    label: PropTypes.string.isRequired,
};

export default CustomTextButtom;
